enum ConditionVersementEtat {
	VERSEMENT_DEMANDE = 'VD',
	VERSEMENT_A_DEMANDER = 'VAD',
	EN_ALERTE = 'A',
	HORS_DELAIS = 'HD',
	NON_REMPLIS = 'NR',
}

export default ConditionVersementEtat;
